export default Object.freeze({
  CREDENTIALS: "CREDENTIALS",
  LAST_EVENT_TRACKING_LOCATION: "LAST_EVENT_TRACKING_LOCATION",
  ALREADY_SENT_ACTIVE_PARAMS: "ALREADY_SENT_ACTIVE_PARAMS",
});
